import { NgModule } from "@angular/core";
import { PlanungApiProcessingOrderComponent } from "./planung-processing-order.component";
import { CommonComponentsModule } from 'src/app/common-components';
import { PlanungApiRoutingModule } from '../planung-api-routing.module';
import { AnlageApiComponentsModule } from "src/app/anlage-api/components/anlage-components.module";
import { MatExpansionModule } from "@angular/material/expansion";
@NgModule({
  imports: [CommonComponentsModule, AnlageApiComponentsModule, PlanungApiRoutingModule, MatExpansionModule],
  declarations: [PlanungApiProcessingOrderComponent],
})
export class PlanungApiProcessingOrderModule { }
